import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";
import { StateService, TransitionService } from "@uirouter/core";
import { DialogService } from "@app/services/dialog.service";
import { DrawerService } from "@app/services/drawer.service";
import { SignalrService } from "@app/services/signalr.service";
import { ApiService } from "@app/services/api.service";
import { AuthService } from "@app/services/auth.service";
import { IPromiseTracker } from "angular";
import { KbService } from "@app/services/kb.service";

/**
 * Acts as an aggregate service so consolidate dependencies used
 * across the crudController inherited classes
 */
@NgService({
    token: Token.CrudService,
    dependencies: [
        Token.$Http,
        Token.$StateParams,
        Token.$RootScope,
        Token.$State,
        Token.$Window,
        Token.DialogService,
        Token.DrawerService,
        Token.$Q,
        Token.SignalRService,
        Token.ApiService,
        Token.$Transitions,
        Token.AuthService,
        Token.$Location,
        Token.$Timeout,
        Token.PromiseTracker,
        Token.KbService
    ]
})
export class CrudService {
    constructor(
        public $http: ng.IHttpService,
        public $stateParams: any,
        public $rootScope: IRootScope,
        public $state: StateService,
        public $window: ng.IWindowService,
        public dialogService: DialogService,
        public drawerService: DrawerService,
        public $q: ng.IQService,
        public signalrService: SignalrService,
        public api: ApiService,
        public $transitions: TransitionService,
        public authService: AuthService,
        public $location: ng.ILocationService,
        public $timeout: ng.ITimeoutService,
        public promiseTracker: IPromiseTracker,
        public kbService: KbService
    ) {

    }
}
